import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import GalleryGrid from '../components/GalleryGrid';

export default function CompleteSolutions() {
  const processStages = [
    {
      step: '1',
      title: 'Behov & Idé',
      desc: 'Vi starter med en grundig gennemgang af jeres specifikke produktionsbehov, emner, cyklustider og fysiske rammer.',
      icon: 'fa-solid fa-lightbulb',
    },
    {
      step: '2',
      title: 'Konstruktion & CAD',
      desc: '3D modellering i Inventor, NX eller Creo. Udarbejdelse af samlingstegninger, tolerancer og FEM-styrkeberegninger.',
      icon: 'fa-solid fa-cube',
    },
    {
      step: '3',
      title: 'Elkonstruktion & Tavler',
      desc: 'Komplette eldiagrammer i PC Schematik på Dansk, Tysk eller Engelsk. Bygning af styretavler efter gældende standarder.',
      icon: 'fa-solid fa-bolt',
    },
    {
      step: '4',
      title: 'Automation & Robotter',
      desc: 'PLC-programmering (Siemens, Mitsubishi, Allan Bradley), SCADA og robotbaneplanlægning (KUKA, Motoman, UR).',
      icon: 'fa-solid fa-robot',
    },
    {
      step: '5',
      title: 'Produktion & Montage',
      desc: 'Mekanisk opbygning på værkstedet på Huholt 1A i Sønderborg, bearbejdning af delkomponenter og elektrisk fortrådning.',
      icon: 'fa-solid fa-industry',
    },
    {
      step: '6',
      title: 'Test & Indkøring',
      desc: 'Omfattende funktionstest, sikkerhedsafprøvning, sensorjustering og indkøring før den endelige levering.',
      icon: 'fa-solid fa-vial-circle-check',
    },
    {
      step: '7',
      title: 'Levering & CE-mærkning',
      desc: 'Installation hos kunden, operatøroplæring, overlevering af teknisk dossier og fuld lovpligtig CE-mærkning.',
      icon: 'fa-solid fa-truck-fast',
    },
  ];

  const galleryImages = [
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/automatiske-maskiner-montage.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/hero-automation-engineering.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/elkonstruktion-styretavle.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/2dee4a-f13a7513b1d94a9ca64d009f1172fcf7-mv2.jpg',
  ];

  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="Komplette løsninger - JARCon ApS"
        description="Samlet mekatronik leverandør fra idé og konstruktion til el, automation, montage, test og CE-mærkning."
      />

      <PageHeader
        badge="Totalløsninger"
        title="Komplette løsninger"
        subtitle="Fra idé og konstruktion til færdigt system i drift • Én samlet mekatronik-partner"
        breadcrumbs={[{ label: 'Komplette løsninger' }]}
        ctaText="Drøft dit projekt med os"
        ctaLink="/kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Intro */}
        <div className="max-w-3xl mb-16 p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
          <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest font-semibold block">
            Mekatronik totalløsning
          </span>
          <h2 className="font-display text-2xl font-bold text-white">
            Én samarbejdspartner dækker hele værdikæden
          </h2>
          <p className="text-slate-300 text-base leading-relaxed">
            Mekatronik omfatter mekanik, elektronik og software/programmering. Ved at samle alle tre fagområder hos JARCon undgår du de klassiske grænsefladeproblemer, der ofte opstår mellem konstruktøren, tavlebyggeren og programmøren.
          </p>
          <p className="text-slate-400 text-sm leading-relaxed">
            Vi tager det fulde tekniske ansvar fra den første skitse til maskinen producerer hos jer.
          </p>
        </div>

        {/* Process Stages Timeline */}
        <div className="mb-16">
          <div className="mb-8">
            <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest block mb-1 font-semibold">
              Procestrin
            </span>
            <h3 className="font-display text-2xl font-bold text-white">
              Vores 7-trins model for komplette leverancer
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {processStages.map((stage) => (
              <div
                key={stage.step}
                className="p-6 rounded-xl bg-[#0e1622] border border-slate-800 relative overflow-hidden flex flex-col justify-between"
              >
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <span className="w-9 h-9 rounded-lg bg-cyan-500 text-white font-display font-black text-base flex items-center justify-center shadow-md">
                      {stage.step}
                    </span>
                    <i className={`${stage.icon} text-slate-500 text-lg`} aria-hidden="true" />
                  </div>
                  <h4 className="font-display font-bold text-lg text-white mb-2">
                    {stage.title}
                  </h4>
                  <p className="text-xs text-slate-400 leading-relaxed font-sans">
                    {stage.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Gallery */}
        <GalleryGrid
          title="Komplette maskiner og anlæg"
          subtitle="Se eksempler på maskinkonstruktion og montage"
          images={galleryImages}
        />
      </div>
    </div>
  );
}
